import type { WizardVerticalLabels, VerificationMethod } from '@lipaflow/shared'

export interface StepProps {
  tenantId: string
  verticalLabels: WizardVerticalLabels
}

export type { WizardVerticalLabels, VerificationMethod }

/** Default labels used when vertical config doesn't provide overrides */
export const DEFAULT_LABELS: WizardVerticalLabels = {
  name: 'Organization Name',
  entity: 'Entity',
  obligation: 'Fee',
  admin: 'Administrator',
}

/** Merge vertical labels with defaults */
export function resolveLabels(labels?: WizardVerticalLabels): Required<Pick<WizardVerticalLabels, 'name' | 'entity' | 'obligation' | 'admin'>> & WizardVerticalLabels {
  return {
    ...DEFAULT_LABELS,
    ...labels,
  } as Required<Pick<WizardVerticalLabels, 'name' | 'entity' | 'obligation' | 'admin'>> & WizardVerticalLabels
}
